import moment from 'moment';

export const MARKET_ANALYSIS_NAV_CONFIG = [
	{
		name: 'apvendor-library',
		label: 'Vendor Database',
		path: '/market-analysis/vendor-database',
		lastRoute: 'vendor-database',
	},
	{
		name: 'suplier-diversity-database',
		label: 'Supplier Diversity Database',
		path: '/market-analysis/suplier-diversity-database',
		lastRoute: 'suplier-diversity-database',
	},
];

export const getUploadedTime = dateString => {
	const utcDate = new Date(dateString);
	const myLocalDate = new Date(
		Date.UTC(
			utcDate.getFullYear(),
			utcDate.getMonth(),
			utcDate.getDate(),
			utcDate.getHours(),
			utcDate.getMinutes()
		)
	);

	const today = moment();
	const momentDate = moment(myLocalDate);

	return momentDate.isSame(today, 'day')
		? `${momentDate.format('h:mma')} today`
		: `${momentDate.format('h:mma')} on ${momentDate.format('MMM D YYYY')}`;
};

export const getCurrencySymbolFromOptions = (options, currency) => {
	if (!options) {
		return currency ? currency.toUpperCase() : '';
	}

	if (!currency) {
		return '';
	}

	const currencyObj =
		options.find(item => item.code === currency.toLowerCase()) || {};

	return currencyObj.symbol || currency.toUpperCase();
};

export const ROOT_ROUTE = '/market-analysis/suplier-diversity-database';
export const SUPPLIER_DIVERSITY_ANALYZE_DATA_SUBMENU = [
	{
		name: 'AnalyzeClientData',
		label: 'Analyze Client Data',
		child: [
			{
				path: `${ROOT_ROUTE}/analyze-edit-data`,
				name: 'editData',
				label: 'Analyze/Edit Data',
			},
			{
				path: `${ROOT_ROUTE}/supplier-diversity-stats`,
				name: 'diversityStats',
				label: 'Supplier Diversity Stats',
			},
			{
				path: `${ROOT_ROUTE}/upload-data`,
				name: 'uploadData',
				label: 'Upload Data',
			},
		],
	},
	{
		name: 'APStats',
		label: 'AlixPartners Stats',
		path: `${ROOT_ROUTE}/alixparnters-stats`,
		child: [
			{
				path: `${ROOT_ROUTE}/alixparnters-stats`,
				name: 'apStats',
				label: 'AlixPartners Stats',
			},
		],
	},
	{
		name: 'ExploreLibrary',
		label: 'Explore Library',
		path: `${ROOT_ROUTE}/explore-library`,
		child: [
			{
				path: `${ROOT_ROUTE}/explore-library`,
				name: 'exploreLibrary',
				label: 'Explore Library',
			},
		],
	},
];
